module.exports = __webpack_public_path__ + "img/timer.44d9a0e0.svg";